export const GET_CONSULTANCY_DROPDOWN_REQUEST = "GET_CONSULTANCY_DROPDOWN_REQUEST";
export const GET_CONSULTANCY_DROPDOWN_SUCCESS = "GET_CONSULTANCY_DROPDOWN_SUCCESS";
export const GET_CONSULTANCY_DROPDOWN_FAILURE = "GET_CONSULTANCY_DROPDOWN_FAILURE";

export const GET_CLIENTS_DROPDOWN_REQUEST = "GET_CLIENTS_DROPDOWN_REQUEST";
export const GET_CLIENTS_DROPDOWN_SUCCESS = "GET_CLIENTS_DROPDOWN_SUCCESS";
export const GET_CLIENTS_DROPDOWN_FAILURE = "GET_CLIENTS_DROPDOWN_FAILURE";

export const GET_SECTOR_DROPDOWN_REQUEST = "GET_SECTOR_DROPDOWN_REQUEST";
export const GET_SECTOR_DROPDOWN_SUCCESS = "GET_SECTOR_DROPDOWN_SUCCESS";
export const GET_SECTOR_DROPDOWN_FAILURE = "GET_SECTOR_DROPDOWN_FAILURE";

export const GET_CAMPUSES_DROPDOWN_REQUEST = "GET_CAMPUSES_DROPDOWN_REQUEST";
export const GET_CAMPUSES_DROPDOWN_SUCCESS = "GET_CAMPUSES_DROPDOWN_SUCCESS";
export const GET_CAMPUSES_DROPDOWN_FAILURE = "GET_CAMPUSES_DROPDOWN_FAILURE";

export const GET_LOGBOOK_DROPDOWN_REQUEST = "GET_LOGBOOK_DROPDOWN_REQUEST";
export const GET_LOGBOOK_DROPDOWN_SUCCESS = "GET_LOGBOOK_DROPDOWN_SUCCESS";
export const GET_LOGBOOK_DROPDOWN_FAILURE = "GET_LOGBOOK_DROPDOWN_FAILURE";

export const GET_DEEMING_AGENCY_DROPDOWN_REQUEST = "GET_DEEMING_AGENCY_DROPDOWN_REQUEST";
export const GET_DEEMING_AGENCY_DROPDOWN_SUCCESS = "GET_DEEMING_AGENCY_DROPDOWN_SUCCESS";
export const GET_DEEMING_AGENCY_DROPDOWN_FAILURE = "GET_DEEMING_AGENCY_DROPDOWN_FAILURE";

export const GET_FREQUENCY_DROPDOWN_REQUEST = "GET_FREQUENCY_DROPDOWN_REQUEST";
export const GET_FREQUENCY_DROPDOWN_SUCCESS = "GET_FREQUENCY_DROPDOWN_SUCCESS";
export const GET_FREQUENCY_DROPDOWN_FAILURE = "GET_FREQUENCY_DROPDOWN_FAILURE";

export const GET_ROLE_DROPDOWN_REQUEST = "GET_ROLE_DROPDOWN_REQUEST";
export const GET_ROLE_DROPDOWN_SUCCESS = "GET_ROLE_DROPDOWN_SUCCESS";
export const GET_ROLE_DROPDOWN_FAILURE = "GET_ROLE_DROPDOWN_FAILURE";

export const GET_BUILDING_TYPE_DROPDOWN_REQUEST = "GET_BUILDING_TYPE_DROPDOWN_REQUEST";
export const GET_BUILDING_TYPE_DROPDOWN_SUCCESS = "GET_BUILDING_TYPE_DROPDOWN_SUCCESS";
export const GET_BUILDING_TYPE_DROPDOWN_FAILURE = "GET_BUILDING_TYPE_DROPDOWN_FAILURE";

export const GET_TEMPLATE_DROPDOWN_REQUEST = "GET_TEMPLATE_DROPDOWN_REQUEST";
export const GET_TEMPLATE_DROPDOWN_SUCCESS = "GET_TEMPLATE_DROPDOWN_SUCCESS";
export const GET_TEMPLATE_DROPDOWN_FAILURE = "GET_TEMPLATE_DROPDOWN_FAILURE";

export const GET_TEMPLATE_INITIAL_VALUES_REQUEST = "GET_TEMPLATE_INITIAL_VALUES_REQUEST";
export const GET_TEMPLATE_INITIAL_VALUES_SUCCESS = "GET_TEMPLATE_INITIAL_VALUES_SUCCESS";
export const GET_TEMPLATE_INITIAL_VALUES_FAILURE = "GET_TEMPLATE_INITIAL_VALUES_FAILURE";

export const GET_BUILDINGS_DROPDOWN_REQUEST = "GET_BUILDINGS_DROPDOWN_REQUEST";
export const GET_BUILDINGS_DROPDOWN_SUCCESS = "GET_BUILDINGS_DROPDOWN_SUCCESS";
export const GET_BUILDINGS_DROPDOWN_FAILURE = "GET_BUILDINGS_DROPDOWN_FAILURE";

export const GET_ASSET_CONDITIONS_DROPDOWN_REQUEST = "GET_ASSET_CONDITIONS_DROPDOWN_REQUEST";
export const GET_ASSET_CONDITIONS_DROPDOWN_SUCCESS = "GET_ASSET_CONDITIONS_DROPDOWN_SUCCESS";
export const GET_ASSET_CONDITIONS_DROPDOWN_FAILURE = "GET_ASSET_CONDITIONS_DROPDOWN_FAILURE";

export const GET_FLOORS_DROPDOWN_REQUEST = "GET_FLOORS_DROPDOWN_REQUEST";
export const GET_FLOORS_DROPDOWN_SUCCESS = "GET_FLOORS_DROPDOWN_SUCCESS";
export const GET_FLOORS_DROPDOWN_FAILURE = "GET_FLOORS_DROPDOWN_FAILURE";

export const GET_EVENT_FORM_DROPDOWN_REQUEST = "GET_EVENT_FORM_DROPDOWN_REQUEST";
export const GET_EVENT_FORM_DROPDOWN_SUCCESS = "GET_EVENT_FORM_DROPDOWN_SUCCESS";
export const GET_EVENT_FORM_DROPDOWN_FAILURE = "GET_EVENT_FORM_DROPDOWN_FAILURE";
